import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=059a9bce&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059a9bce')) {
      api.createRecord('059a9bce', component.options)
    } else {
      api.reload('059a9bce', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=059a9bce&", function () {
      api.rerender('059a9bce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OZFmTReKQEwM/JS/ImageCarousel.vue"
export default component.exports